import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import OtpInput from "react-otp-input"; // Assurez-vous d'avoir installé cette dépendance
import "./OtpInputWithValidation.scss";
import { useDispatch } from "react-redux"; // Pour utiliser dispatch
import { verifyOtp } from "../../store/authSlice"; // Importer le thunk

const OtpForm = () => {
  const [otp, setOtp] = useState(""); // L'OTP que l'utilisateur saisit
  const [isComplete, setIsComplete] = useState(false); // Vérifier si l'OTP est complet
  const [timeLeft, setTimeLeft] = useState(300); // Temps restant en secondes (10 minutes = 600 secondes)
  const navigate = useNavigate(); // Pour la redirection après la vérification de l'OTP
  const dispatch = useDispatch(); // Pour dispatcher l'action
  const [isLoading, setIsLoading] = useState(false); // État pour gérer le chargement


  // Fonction pour formater le temps en minute:seconde
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${
      remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds
    }`;
  };

  // Gérer la soumission de l'OTP
  const handleSubmit = async () => {
    if (isComplete) {
      try {
        setIsLoading(true); // Début du chargement
        // Dispatch de l'action pour vérifier l'OTP
        const actionResult = await dispatch(verifyOtp(otp));

        if (verifyOtp.fulfilled.match(actionResult)) {
          // Si l'OTP est validé avec succès, redirigez l'utilisateur
          toast.success("OTP Verified Successfully", {
            className: "toast-success",
            closeButton: false,
            autoClose: 2000,
          });

          // Rediriger après la connexion réussie
          setTimeout(() => {
            navigate("/"); // Redirection vers la page d'accueil
          }, 2000);
        }
      } catch (error) {
        // Si l'OTP est incorrect ou expiré, l'erreur venant du backend est capturée ici
        const errorMessage ="OTP verification failed";
        console.log('kdkdkdjdjn',errorMessage)
        toast.error(errorMessage, {
          className: "toast-error",
          closeButton: false,
          autoClose: 2000,
        });
      } 
      finally {
        setIsLoading(false); // Fin du chargement
      }
    } else {
      toast.error("Please enter a valid OTP", {
        className: "toast-error",
        closeButton: false,
        autoClose: 2000,
      });
    }
  };

  useEffect(() => {
    // Vérifier si l'OTP est complet (6 chiffres)
    if (otp.length === 6) {
      setIsComplete(true);
    } else {
      setIsComplete(false);
    }
    // Démarrer le décompte du temps
    const timer = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(timer); // Arrêter le timer une fois que le temps est écoulé
          navigate("/login"); // Rediriger vers la page de connexion
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000); // Met à jour le temps chaque seconde

    // Nettoyer l'intervalle lorsqu'on quitte le composant
    return () => clearInterval(timer);
  }, [otp]);

  // Fonction pour n'accepter que les chiffres
  const handleOtpChange = (value) => {
    // N'accepter que les chiffres
    if (/^\d*$/.test(value)) {
      setOtp(value);
    }
  };

  return (
    <div className="login">
      <div className="otp_form_container">
        <div className="top">
          <h1 className="title">OTP Verification</h1>
          <p className="text_muted">Enter the OTP code sent to your email</p>
        </div>
        <div className="middle">
          <div className="wrapper">
            <OtpInput
              value={otp}
              onChange={handleOtpChange}
              numInputs={6} // Nombre de cases pour l'OTP
              renderSeparator={<span className="otp_separator">|</span>}
              renderInput={(props) => (
                <input {...props} type="tel" inputMode="numeric" />
              )}
            />
          </div>
          <div
            className={`countdown ${timeLeft <= 30 ? "warning" : ""} ${
              timeLeft === 0 ? "expired" : ""
            }`}
          >
            <p>
              Expires in : <span>{formatTime(timeLeft)}</span>
            </p>
          </div>
        </div>
        <div className="bottom">
          <button
            onClick={handleSubmit}
            className={`submit_btn ${
              !isComplete || timeLeft === 0 ? "disabled" : ""
            }`}
            disabled={!isComplete || timeLeft === 0}
          >
            {isLoading ? (
              <div className="loaders"></div> // Ajoutez votre spinner ici
            ) : (
              "Verify OTP"
            )}
          </button>
        </div>
      </div>
      <ToastContainer hideProgressBar={false} limit={1} />
    </div>
  );
};

export default OtpForm;
